import { observer } from 'mobx-react-lite';
import React from 'react';
import { colors } from '../../../../colorVars';
import { useWebsocketStore } from '../../../../stores/websocketStore/websocketProvider';
import { Body3 } from '../../../atomic/text/Text';
import { getNotificationSymbol } from '../../../../stores/websocketStore/utils/mungingUtils/notifications/higherOrderHandlers/getNotificationSymbol';
import { getNotificationType } from '../../../../stores/websocketStore/utils/mungingUtils/notifications/higherOrderHandlers/getNotificationType';
import { timeStampTo24HourEST } from '../../../../stores/websocketStore/utils/mungingUtils/timeFormatting/timeStampTo24HourEST';
import { translateOptionSymbol } from '../../../../stores/websocketStore/utils/mungingUtils/translateOptionSymbol';
import { getNotificationStatusComponent } from '../../../../stores/websocketStore/utils/mungingUtils/notifications/higherOrderHandlers/getNotificationStatusComponent';
import * as ReactDOMServer from 'react-dom/server';

const notificationTypeToColorMap = {
  TRADE_PLAN_UPDATE: colors.blue,
  WARNING: colors.orange,
  ERROR: colors.red,
};
export const ActivityLogsTableRow = observer(({ id }) => {
  const { activityLogsStore } = useWebsocketStore();
  const notification = activityLogsStore.logs[id];
  const symbol = getNotificationSymbol(notification) ?? 'N/A';
  const { type, text } = getNotificationType(notification);
  const [StatusComponent, parsedStatusObj] = getNotificationStatusComponent(
    notification
  ) ?? [null, null];
  const time = timeStampTo24HourEST(notification.timestamp);
  const string = ReactDOMServer.renderToString(
    <StatusComponent parsedStatusObj={parsedStatusObj} />
  ).replace(/<[^>]*>/g, '');

  return (
    <tr title={string}>
      <td>
        <Body3 color={colors.lightGrey} fontWeight={600}>
          {time}
        </Body3>
      </td>
      <td
        style={{ maxWidth: '90px', overflow: 'hidden' }}
        title={symbol.length > 6 ? translateOptionSymbol(symbol) : symbol}
      >
        <Body3 color={colors.lightGrey} fontWeight={600}>
          {symbol !== 'N/A'
            ? symbol.length > 6
              ? translateOptionSymbol(symbol)
              : symbol
            : symbol}
        </Body3>
      </td>
      <td>
        <Body3 color={notificationTypeToColorMap[type]} fontWeight={600}>
          {text}
        </Body3>
      </td>
      {StatusComponent ? (
        <StatusComponent parsedStatusObj={parsedStatusObj} />
      ) : (
        <td></td>
      )}
    </tr>
  );
});
